<template>
  <div class="avatar-wrapper" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails' }">
    <div v-if="!isEditCustomer">
      <div class="img-containerInner" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails' }" v-if="customer.image != null" :style="{ background: `url('${customer.image}') no-repeat center / cover` }"></div>
      <div class="img-containerInner" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails' }" v-else :style="{ background: 'url(' + require('@/resources/images/no_photo.svg') + ') no-repeat center / cover' }"></div>
    </div>
    <div v-if="isEditCustomer" class="flex-center">
      <upload-files-v-2 type="image" :multiple="false" allowedImageTypes='image/png, image/jpeg, image/jpg' id="'customerImage'" ref="customerImage" :maxFileSizeAllowed="5" v-model:loading="uploadingImage" @send-upload-data="handleImageUpload" :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: undefined}">
        <div class="cursorPointer upload-slot-center" title="Upload Image">
          <div v-if="!uploadingImage">
            <div class="img-containerInner" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails' }" v-if="customer.image != null" :style="{ background: `url('${customer.image}') no-repeat center / cover` }"></div>
            <div class="img-containerInner" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails' }" v-else :style="{ background: 'url(' + require('@/resources/images/no_photo.svg') + ') no-repeat center / cover' }"></div>
          </div>
          <VProgressRing v-else class="vvd-spinner uploadImgContainer" connotation="cta" indeterminate />
        </div>
      </upload-files-v-2>
    </div>
    <!-- Channel icon overlay -->
    <p class="overUserImageChannelIconContainer" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails', 'customer_edit': placement == 'custom_edit_details' }" v-if="customer.platform == 'googlercs' || customer.channel == 'googlercs'" title="Google RCS">
      <img src="../resources/images/Google_RCS_icon.svg" alt="googleRCS" class="platformIconInLineWithText" :class="{ 'customerDetails': placement == 'customerDetails' }"/>
    </p>
    <p class="overUserImageChannelIconContainer" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails', 'customer_edit': placement == 'custom_edit_details' }" v-if="customer.platform == 'whatsapp' || customer.channel == 'whatsapp'" title="WhatsApp">
      <img src="@/resources/images/whatsapp_icon.svg" alt="whatsapp" class="platformIconInLineWithText" :class="{ 'customerDetails': placement == 'customerDetails' }"/>
    </p>
    <p class="overUserImageChannelIconContainer" :class="{ 'sideBarImage': placement == 'sideBar', 'customerDetails': placement == 'customerDetails', 'customer_edit': placement == 'custom_edit_details' }" v-if="customer.platform == 'sms' || customer.channel == 'sms'" title="SMS">
      <img src="../resources/images/sms_logo.svg" alt="sms" class="platformIconInLineWithText" :class="{ 'customerDetails': placement == 'customerDetails' }">
    </p>
  </div>
</template>
<script>
import uploadFilesV2 from "@/components/uploadFilesV2.vue";
import { useUIStore } from '@/stores/ui';
export default {
  components: { uploadFilesV2 },
  emits: ['customer_image_updated'],
  props: {
    customer: {
      type: Object,
      default: () => {
        return {};
      },
    },
    placement: {
      type: String,
    },
    isEditCustomer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadingImage: false,
    }
  },
  methods: {
    async handleImageUpload (urlData) {
      try {
        this.uploadingImage = true;
        var image_url = urlData[0].url;
        this.$emit('customer_image_updated', { image_url });
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.uploadingImage = false;
      }
    },
  }
}
</script>
<style scoped>
.avatar-wrapper {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
}
.avatar-wrapper.sideBarImage {
  width: 50px;
  height: 50px;
  margin: 10px 15px 10px 0px;
}
.avatar-wrapper.customerDetails {
  width: 80px;
  height: 80px;
}
.img-containerInner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-size: cover !important;
  background-position: center !important;
}
.img-containerInner.sideBarImage {
  width: 50px;
  height: 50px;
}
.img-containerInner.customerDetails {
  width: 80px;
  height: 80px;
}

/* Channel icon badge overlay */
p.overUserImageChannelIconContainer {
  position: absolute;
  bottom: -5px;
  right: -2px;
  padding: 0px;
  margin: 0px;
  line-height: 1;
  width: 25px;
  height: 25px;
  background: var(--white);
  border-radius: 50%;
  display: inline-block;
}
p.overUserImageChannelIconContainer img.platformIconInLineWithText {
  margin: 5px 5px 0px 5px;
  width: 15px;
  height: 15px;
}
p.overUserImageChannelIconContainer.sideBarImage {
  bottom: -2px;
  right: -2px;
  width: 25px;
  height: 25px;
}
p.overUserImageChannelIconContainer.customer_edit {
  right: -5px;
}
p.overUserImageChannelIconContainer img.platformIconInLineWithText.customerDetails {
  margin: 7px 0 0 2px;
  width: 20px;
  height: 20px;
}
p.overUserImageChannelIconContainer.customerDetails {
  bottom: -3px;
  right: 0px;
  width: 30px;
  height: 30px;
  text-align: center;
}
.flex-center {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-center :deep(.upload-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-center :deep(.upload-wrapper.with-content) {
  padding: 28px;
}
.uploadImgContainer {
  width: 30px;
  height: 30px;
}
.upload-slot-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
